export const requestsComposer = (search: string): boolean =>
  new URLSearchParams(search).get('add') === '1';

export const withoutComposerRequest = (search: string): string => {
  const params = new URLSearchParams(search);
  params.delete('add');
  const next = params.toString();
  return next ? `?${next}` : '';
};

export const requestsPropertyComposer = requestsComposer;
export const withoutPropertyComposerRequest = withoutComposerRequest;
